import { useEffect } from "react";
import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "../../store";
import * as rssFeedActions from "../../store/education/actions";
import { Link } from "react-router-dom";
import i18nService from "../../util/Internationalization/i18n/i18n";
import { getFormattedDate } from "../../util/dateFormatting";
import { useTranslation } from "react-i18next";

const EducationArticle = () => {
    const dispatch = useDispatch();

    const isBusinessUser = useSelector((state: ApplicationState) => state.loggedInUser && state.loggedInUser.userServiceDetails?.isBusinessUser);
    const userType = isBusinessUser ? "business" : "personal";
    const requestArticleData = () => dispatch(rssFeedActions.actionCreators.getRssFeedData(userType));

    const educationData = useSelector((state: ApplicationState) => (state.educationState ? state.educationState.educationData : []));
    const hasEducationAndBreach = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.hasEducationAndBreach
            ? state.configurationState.configuration.partnerConfig.hasEducationAndBreach
            : false
    );
    const isWhiteLabeled = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.isWhiteLabeled
            ? state.configurationState.configuration.partnerConfig.isWhiteLabeled
            : false
    );
    const { t: tLang, i18n: i18nLang } = useTranslation();

    useEffect(() => {
        requestArticleData();
    }, []);

    if (hasEducationAndBreach || !isWhiteLabeled) {
        return (
            <React.Fragment>
                {i18nLang && i18nLang.language === "en" && (
                    <div className="box">
                        <div className="box-header">
                            <div className="box-title-container">
                                <div className="box-title-text has-actions">
                                    <h2 className="box-title heading-title">{tLang("dashboard.education.title")}</h2>
                                </div>
                            </div>
                            <div className="box-actions">
                                <Link to={isBusinessUser ? "/resources/business-education" : "/resources/education"} className="default_link">
                                    <span className="nav-text">View more Articles</span>
                                </Link>
                            </div>
                        </div>
                        <div className="box-content">
                            <ul className="article-list column-2">
                                {educationData != null &&
                                    educationData.slice(0, 2).map((data: any, index: number) => (
                                        <li key={index}>
                                            <div className="article-container">
                                                <div className="article-image">
                                                    <Link
                                                        rel="noreferrer"
                                                        to={
                                                            (isBusinessUser ? "/resources/business-education?" : "/resources/education?") +
                                                            data.feedUrl.split("resources/")[1].replace("/", "")}
                                                        aria-label={data.title}
                                                        tabIndex={-1}
                                                    >
                                                        <img
                                                            style={{ left: "0%", top: "0%", transform: "none" }}
                                                            src={data.imageUrl}
                                                            alt="Article Image"
                                                        />
                                                    </Link>
                                                </div>
                                                <div className="article-content">
                                                    <h4 className="article-title">
                                                        <Link
                                                            rel="noreferrer"
                                                            to={
                                                                (isBusinessUser ? "/resources/business-education?" : "/resources/education?") +
                                                                data.feedUrl?.split("resources/")[1].replace("/", "")
                                                            }
                                                            title={data.title}
                                                        >
                                                            {data.title.length > 57 ? data.title.substring(0, 57) + "..." : data.title}
                                                        </Link>
                                                    </h4>
                                                    <div className="article-intro">
                                                        <p style={{ maxHeight: "100px", textOverflow: "ellipsis", overflow: "hidden" }}>
                                                            {data && data.summary && data.summary.length > 197 ? data.summary.substring(0, 197) + "..." : data.summary}
                                                        </p>
                                                    </div>
                                                </div>
                                                {/* <div className="article-author-and-date">
                                                    <div className="article-author-text">
                                                        <div className="article-author-name">
                                                            <span className="sr-only">Author: </span>
                                                            {data.author}
                                                        </div>
                                                        <div className="article-published-date">
                                                            <span className="sr-only">{tLang("dashboard.education.publishedOn")}:</span>
                                                            {getFormattedDate(i18nService.get("Country"), data.publishDate)}
                                                        </div>
                                                    </div>
                                                </div> */}
                                            </div>
                                        </li>
                                    ))}
                            </ul>
                        </div>
                    </div>
                )}
            </React.Fragment>
        );
    } else {
        return <></>;
    }
};

export default EducationArticle;
